<template>
  <div :class="['progress-bar-item', statusClassName]">
    <div></div>
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    statusClassName: function () {
      return `progress-bar-item--${this.status}`;
    },
  },
};
</script>
